module.exports = __webpack_public_path__ + "img/heart_nebula_sho_one.e84d942d.jpg";